import { InjectionToken } from '@angular/core';
import { OwlCarouselConfig } from './models/owl-carousel-config.modal';

export const owlCarouselConfig = new InjectionToken<OwlCarouselConfig>('appOwlCarouselConfig');
